import {RouteHelperItem} from './core/utilities/router-helper';

/*const Window = require('window');
global['window'] = new Window();
global['document'] = global['window'].document;*/

import '@angular/localize/init';
import {Route} from '@angular/router';
import {routes as authModuleRoutes} from '../app/auth/auth.routes';
import {routes as homeModuleRoutes} from '../app/home/home.routes';
import {routes as cpModuleRoutes} from '../app/cp/cp.routes';
import {routes as reportsModuleRoutes} from '../app/reports/reports.routes';
import {appRoutes} from './app.routes';
import {routes as accountModuleRoutes} from '../app/account/account.routes';
import {routes as callLogsModuleRoutes} from '../app/basic-call-logs/basic-call-logs.routes';
import {routes as phoneNumbersModuleRoutes} from '../app/phone-numbers/phone-numbers.routes';
import {routes as firewallModuleRoutes} from '../app/firewall/firewall.routes';
import {routes as messagingModuleRoutes} from '../app/messaging/messaging.routes';
import {routes as messageBroadcastingModuleRoutes} from '../app/message-broadcasting/message-broadcasting.routes';
import {routes as proMessagingModuleRoutes} from '../app/pro-messaging/pro-messaging.routes';
import {routes as proMessagingAutomationModuleRoutes} from '../app/pro-messaging-automation/pro-messaging-automation.routes';
import {routes as proMessagingTemplateModuleRoutes} from '../app/pro-messaging-template/pro-messaging-template.routes';
import {routes as proMessagingWhatsAppTemplateModuleRoutes} from '../app/pro-messaging-whats-app-template/pro-messaging-whats-app-template.routes';
import {routes as proMessagingReportsModuleRoutes} from '../app/pro-messaging-reports/pro-messaging-reports.routes';
import {routes as faxModuleRoutes} from '../app/fax/fax.routes';
import {routes as pbxModuleRoutes} from '../app/pbx/pbx.routes';
import {routes as contactModuleRoutes} from '../app/contact/contact.routes';
import {routes as softphoneModuleRoutes} from '../app/softphone/soft-phone.routes';
import {routes as basicSoftphoneModuleRoutes} from '../app/basic-softphone/basic-soft-phone.routes';
import {routes as videoConferenceRoutes} from '../app/video-conference/video-conference.routes';
import {routes as downloadsRoutes} from '../app/downloads/downloads.routes';
import {routes as customFieldsRoutes} from '../app/account/custom-fields/custom-fields.routes';
import {routes as eventsFlowRoutes} from '../app/events-flow/events-flow.routes';

const ROOT_ROUTE = 'root';

export class RouterGenerator {

  public static allRoutes: RouteHelperItem[];
  private static AppRoutes = {};

  public static registerRoute(moduleName: string, routeConfig: any): void {
    RouterGenerator.AppRoutes[moduleName] = routeConfig;
  }

  public static getRouteByComponent(component: string) {
    return this.allRoutes.find(route => route.key === component);
  }

  static async initAllModules() {

    RouterGenerator.registerRoute(ROOT_ROUTE, appRoutes);
    RouterGenerator.registerRoute('CpModule', cpModuleRoutes);

    RouterGenerator.registerRoute('SoftPhoneModule', softphoneModuleRoutes);
    RouterGenerator.registerRoute('BasicSoftPhoneModule', basicSoftphoneModuleRoutes);
    RouterGenerator.registerRoute('AuthModule', authModuleRoutes);
    RouterGenerator.registerRoute('HomeModule', homeModuleRoutes);
    RouterGenerator.registerRoute('ReportsModule', reportsModuleRoutes);
    RouterGenerator.registerRoute('AccountModule', accountModuleRoutes);
    RouterGenerator.registerRoute('BasicCallLogsModule', callLogsModuleRoutes);
    RouterGenerator.registerRoute('PhoneNumbersModule', phoneNumbersModuleRoutes);
    RouterGenerator.registerRoute('FirewallModule', firewallModuleRoutes);
    RouterGenerator.registerRoute('MessagingModule', messagingModuleRoutes);
    RouterGenerator.registerRoute('ProMessagingModule', proMessagingModuleRoutes);
    RouterGenerator.registerRoute('MessageBroadcastingModule', messageBroadcastingModuleRoutes);
    RouterGenerator.registerRoute('ProMessagingAutomationModule', proMessagingAutomationModuleRoutes);
    RouterGenerator.registerRoute('ProMessagingTemplateModule', proMessagingTemplateModuleRoutes);
    RouterGenerator.registerRoute('ProMessagingWhatsAppTemplateModule', proMessagingWhatsAppTemplateModuleRoutes);
    RouterGenerator.registerRoute('ProMessagingReportsModule', proMessagingReportsModuleRoutes);
    RouterGenerator.registerRoute('FaxModule', faxModuleRoutes);
    RouterGenerator.registerRoute('PbxModule', pbxModuleRoutes);
    RouterGenerator.registerRoute('EventsFlowModule', eventsFlowRoutes);
    RouterGenerator.registerRoute('ContactModule', contactModuleRoutes);
    RouterGenerator.registerRoute('VideoConferenceModule', videoConferenceRoutes);
    RouterGenerator.registerRoute('DownloadsModule', downloadsRoutes);
    RouterGenerator.registerRoute('CustomFieldsModule', customFieldsRoutes);


    await RouterGenerator.initAppRoute();
  }

  static async initAppRoute() {
    console.log('initialize route definition');

    const root = RouterGenerator.AppRoutes[ROOT_ROUTE] as Route[];

    if (!root) {
      throw Error('App route definition is undefined');
    }

    RouterGenerator.allRoutes = [];

    for (const route of root) {
      if (!route.redirectTo) {
        await RouterGenerator.getComponentPath('', route, RouterGenerator.allRoutes);
      }
    }

    // console.log(RouterGenerator.allRoutes);
  }

  static async getComponentPath(path: string, route: Route, allRoutes: any[]) {
    // console.log(path, route.path);
    if (route.component && !route.loadChildren && !route.children) {
      const pathObject = {
        key: route.component.name.replace('_', ''),
        path: RouterGenerator.updatePath(path, route.path),
        data: route.data
      };

      allRoutes.push(pathObject);

      return;
    }

    if (route.children) {
      const rootPath = RouterGenerator.updatePath(path, route.path);
      for (const childRoute of route.children) {
        await RouterGenerator.getComponentPath(rootPath, childRoute, allRoutes);
      }
    }

    if (route.loadChildren) {
      const loadChildrenFunction: any = route.loadChildren;
      const loadChildrenFunctionString = loadChildrenFunction.toString();
      console.log(loadChildrenFunctionString);
      const splitString = loadChildrenFunctionString.indexOf('.then(m => m.') > -1 ? '.then(m => m.' : '.then((m) => m.';

      const loadChildren = loadChildrenFunctionString.split(splitString)[1].replace(')', '');

      const moduleName = loadChildren;
      console.log(moduleName);
      const moduleRoute = RouterGenerator.AppRoutes[moduleName];

      if (moduleRoute) {
        const rootPath = RouterGenerator.updatePath(path, route.path);
        for (const childRoute of moduleRoute) {
          await RouterGenerator.getComponentPath(rootPath, childRoute, allRoutes);
        }
      }
    }
  }

  static updatePath(currentPath: string, nextPath: string): string {
    let newPath = '';
    if (nextPath.indexOf(':') > -1) {
      newPath = currentPath;
    } else if (currentPath.endsWith('/')) {
      newPath = currentPath + nextPath.replace('/', '');
    } else {
      newPath = currentPath + '/' + nextPath.replace('/', '');
    }

    if (newPath.endsWith('/')) {
      newPath = newPath.substring(0, newPath.length - 1);
    }

    return newPath;
  }
}
